import {
  buildInstagramOAuthUrl,
  clearInstagramOAuthReturnResult,
  getCurrentReturnPath,
  markInstagramOAuthPending,
} from './instagramOAuth';

/**
 * Starts Instagram OAuth with a full same-tab redirect.
 * After authorization, /SocialMediaRedirect exchanges the code and navigates back.
 */
export function launchInstagramOAuthRedirect({
  businessId,
  returnPage,
  returnPath,
}) {
  if (!businessId || !returnPage) {
    return false;
  }

  const resolvedReturnPath =
    returnPath ||
    (typeof window !== 'undefined' ? getCurrentReturnPath() : null);

  clearInstagramOAuthReturnResult();
  markInstagramOAuthPending(businessId, returnPage, resolvedReturnPath);

  const authUrl = buildInstagramOAuthUrl(businessId, returnPage);
  window.location.assign(authUrl);
  return true;
}
